export function selectNotifications(state) {
    // This store just uses a `List`
    return state.notifications;
}



// WEBPACK FOOTER //
// ./src/selectors/notifications.js